import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { X } from '@phosphor-icons/react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-surface-secondary" data-testid="payment-cancel-page">
      <Navbar />
      <div className="flex items-center justify-center min-h-screen pt-16 px-4">
        <div className="w-full max-w-md card text-center">
          <X size={64} weight="duotone" className="text-accent mx-auto mb-4" data-testid="cancel-icon" />
          <h2 className="font-manrope text-2xl font-bold text-primary mb-2">Payment Cancelled</h2>
          <p className="text-secondary mb-6">
            Your payment has been cancelled. No charges were made to your account.
          </p>
          <div className="flex gap-4">
            <button
              onClick={() => navigate('/submit-case')}
              className="flex-1 py-3 border-2 border-primary text-primary font-semibold rounded-full hover:bg-primary hover:text-white transition-all"
              data-testid="retry-button"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate('/patient')}
              className="flex-1 btn-primary py-3"
              data-testid="dashboard-button"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}